'use client';
import React from 'react';
import { sanitizeHtmlString } from '@/utils/text/text';

type RichTextPreformattedProps = {
    text: string;
    className?: string;
};

export const RichTextPreformatted: React.FC<RichTextPreformattedProps> = ({
    text,
    className = 'rich-text-preformatted'
}) => {
    // TODO: remove dangerouslySetInnerHTML
    return <div className={className} dangerouslySetInnerHTML={{ __html: sanitizeHtmlString(text) }} />;
};
